export default __webpack_public_path__ + "static/media/veg.4687aaf2.png";